import { configureStore } from '@reduxjs/toolkit'
import indexReducer from '../reducers';
import pesquisaReducer from '../reducers/pesquisa';
import alertaReducer from '../reducers/alerta';
import exameReducer from '../reducers/exame';
import laudoReducer from '../reducers/laudo';

export const store = configureStore({
    reducer: {
        index: indexReducer,
        pesquisa: pesquisaReducer,
        alerta: alertaReducer,
        exame: exameReducer,
        laudo: laudoReducer
    }
});
